import * as React from 'react';
import { Image } from './layout/Image';

export interface EmptyStateProps {
    header: string;
    subText?: string;
}

export function EmptyState(props: EmptyStateProps) {
    return (
        <div className='empty-state'>
            {/* TODO THH denne skal være png med gennemsigtig baggrund */}
            <Image source='empty.png' />
            <h1>{props.header}</h1>
            <p>{props.subText}</p>            
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/EmptyState.tsx